import axios from 'axios';
import { ladeToken, loescheAuth } from 'core/features/auth/authApi';

/**
 * Axios-Client fuer die Investitionen-API (`/api/investitionen`). nginx leitet
 * `/api/*` an den api-service weiter. Alle Endpunkte sind nutzerbezogen und per
 * JWT geschuetzt; uebertragen werden ausschliesslich verschluesselte Daten
 * (Zero-Knowledge).
 */
const investitionenApi = axios.create({
  baseURL: '/api/investitionen',
  timeout: 30000,
});

investitionenApi.interceptors.request.use((config) => {
  const token = ladeToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

investitionenApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      loescheAuth();
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }
    return Promise.reject(error);
  }
);

const data = (response) => response.data;

export const fetchInvestitionenApi = () => investitionenApi.get('').then(data);
export const createInvestitionApi = (dto) => investitionenApi.post('', dto).then(data);
export const updateInvestitionApi = (uuid, dto) => investitionenApi.put(`/${uuid}`, dto).then(data);
export const deleteInvestitionApi = (uuid) => investitionenApi.delete(`/${uuid}`).then(() => uuid);

// ── Dokumente (verschluesselt, je Bereich + Jahr) ───────
// Auflisten liefert nur Metadaten; der Download den vollen Ciphertext.
export const fetchDokumenteApi = () => investitionenApi.get('/dokumente').then(data);
export const downloadDokumentApi = (uuid) => investitionenApi.get(`/dokumente/${uuid}`).then(data);
export const createDokumentApi = (dto) => investitionenApi.post('/dokumente', dto).then(data);
export const deleteDokumentApi = (uuid) => investitionenApi.delete(`/dokumente/${uuid}`).then(() => uuid);

export default investitionenApi;
